import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { saveUser, saveOrg } from '../../../redux/actions';
import API from '../../../utils/API';
import defaultLogo from '../../../images/Profile_avatar.png';
import ConfirmDeleteAccount from '../settings/ConfirmDeleteAccount';
import './account-page.css';

const Acount: React.FC = () => {
  const [mode, setMode] = useState<'default' | 'edit' | 'saving'>('default');
  const [isConfirmDeleteAccount, setConfirmDeleteAccount] = useState(false);

  const dispatch = useDispatch();
  const redux = useSelector((state: any) => state);
  const reduxOrg = redux?.org;
  const reduxUser = redux?.signin;

  const [input, setInput]: any = useState({ npID: reduxOrg._id });

  const isValidEmail = () =>
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      input.email
    );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (value === '') {
      const t = { ...input };
      delete t[name];
      setInput(t);
      return;
    }
    setInput((p: any) => ({ ...p, [name]: value }));
  };

  const submit = async () => {
    setMode('saving');

    if (input.email || input.confirmEmail) {
      if (!isValidEmail()) {
        window.alert('Please enter a valid email address');
        setMode('edit');
        return;
      }
      if (input.email !== input.confirmEmail) {
        window.alert('Email address and confirmation must match');
        setMode('edit');
        return;
      }
    }

    try {
      const res: any = await API.updateDashboard(input);
      if (res?.data?.user) {
        dispatch(saveUser({ ...reduxUser, ...input }));
      }
      if (res?.data?.nonprofit?.name) {
        dispatch(saveOrg(res?.data?.nonprofit));
      }
      setInput({ npID: reduxOrg?._id });
      setMode('default');
    } catch (e) {
      window.alert('We encountered an error. Please contact us if it happens again, thanks!');
      setMode('edit');
    }
  };

  const closeDelete = () => setConfirmDeleteAccount(false);

  return (
    <div className="account-shell">
      <div className="account-wrap">
        {/* Header: avatar + tiny edit links */}
        <div className="account-header">
          <div className="account-avatar" title="Organization logo">
            <img
              src={reduxOrg.images?.logo ? reduxOrg.images?.logo : defaultLogo}
              alt="Logo"
            />
            {/* <div className="avatar-badge" aria-hidden>📷</div> */}
          </div>

          <div className="account-edit-links">
            {mode === 'default' ? (
              <>
                <span className="tiny-edit" onClick={() => setMode('edit')}>Edit</span>
              </>
            ) : (
              <span className="tiny-edit active" onClick={() => setMode('default')}>Edit</span>
            )}
          </div>
        </div>

        {/* Two-column content */}
        <div className="account-grid">
          {/* Left column */}
          <div>
            {mode === 'default' ? (
              <div className="readonly">
                <div className="field"><label>Organization Name</label><p>{reduxOrg.name}</p></div>
                <div className="field"><label>Phone</label><p>{reduxOrg.telephone}</p></div>
                <div className="field"><label>Email</label><p>{reduxUser.email}</p></div>
                <div className="field"><label>Confirm Email</label><p>{reduxUser.email}</p></div>
              </div>
            ) : (
              <>
                <div className="field">
                  <label>Organization Name</label>
                  <input
                    type="text"
                    name="organizationName"
                    defaultValue={reduxOrg.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="field">
                  <label>Phone</label>
                  <input
                    type="text"
                    name="phone"
                    defaultValue={reduxOrg.telephone}
                    onChange={handleChange}
                  />
                </div>
                <div className="field">
                  <label>Email</label>
                  <input
                    type="text"
                    name="email"
                    defaultValue={reduxUser.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="field">
                  <label>Confirm Email</label>
                  <input
                    type="text"
                    name="confirmEmail"
                    defaultValue={reduxUser.email}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
          </div>

          {/* Right column */}
          <div>
            {mode === 'default' ? (
              <div className="readonly">
                <div className="field"><label>Address</label>
                  <p>{reduxOrg?.address?.addressLine1 || ''}</p>
                </div>
                <div className="field"><label>Address 2</label>
                  <p>{reduxOrg?.address?.addressLine2 || ''}</p>
                </div>
                <div className="rows">
                  <div className="field"><label>City</label><p>{reduxOrg?.address?.city || ''}</p></div>
                  <div className="field"><label>State</label><p>{reduxOrg?.address?.state || ''}</p></div>
                </div>
                <div className="field"><label>Zip Code</label><p>{reduxOrg?.address?.zipcode || ''}</p></div>
              </div>
            ) : (
              <>
                <div className="field">
                  <label>Adress</label>
                  <input
                    type="text"
                    name="address"
                    defaultValue={reduxOrg.address.addressLine1}
                    onChange={handleChange}
                  />
                </div>
                <div className="field">
                  <label>Address 2</label>
                  <input
                    type="text"
                    name="address2"
                    defaultValue={reduxOrg.address.addressLine2}
                    onChange={handleChange}
                  />
                </div>
                <div className="rows">
                  <div className="field">
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      defaultValue={reduxOrg.address.city}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="field">
                    <label>State</label>
                    <input
                      type="text"
                      name="state"
                      defaultValue={reduxOrg.address.state}
                      onChange={handleChange}
                    />
                  </div>
                </div>
               <div className="rows">
                 <div className="field">
                  <label>Zip Code</label>
                  <input
                    type="text"
                    name="zipcode"
                    defaultValue={reduxOrg.address.zipcode}
                    onChange={handleChange}
                  />
                </div>
                <div className=""></div>
               </div>
              </>
            )}
          </div>
        </div>

        {/* Buttons */}
       {mode !== 'default' && (
  <div className="actions">
    <button
      className="btn-pill"
      onClick={submit}
      disabled={mode === 'saving'}
    >
      {mode === 'saving' ? 'Saving…' : 'Save Changes'}
    </button>
    <button
      className="btn-pill"
      onClick={() => { setInput({ npID: reduxOrg._id }); setMode('default'); }}
      disabled={mode === 'saving'}
    >
      Cancel
    </button>
  </div>
)}


        {/* Optional delete account (kept for functionality) */}
      

        {isConfirmDeleteAccount ? <ConfirmDeleteAccount cancelDelete={closeDelete} /> : null}
      </div>
    </div>
  );
};

export default Acount;
